import { render, staticRenderFns } from "./Scrollbars.vue?vue&type=template&id=6ecd0a44&lang=pug&"
import script from "./Scrollbars.vue?vue&type=script&lang=js&"
export * from "./Scrollbars.vue?vue&type=script&lang=js&"
import style0 from "./Scrollbars.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports